import { Suspense, lazy } from "react";
import type { ComponentProps } from "react";
import type AuthModalComponent from "@/components/AuthModal";

const AuthModal = lazy(() => import("@/components/AuthModal"));

type AuthModalProps = ComponentProps<typeof AuthModalComponent>;

/**
 * Envoltorio diferido del modal de autenticación.
 *
 * El modal arrastra el diálogo, los formularios y el botón de Google. Al
 * montarlo solo cuando `open === true` y cargarlo en diferido, ese código sale
 * del bundle inicial de la portada (JS sin usar en PageSpeed) sin cambiar nada
 * del flujo de login.
 */
const LazyAuthModal = (props: AuthModalProps) => {
  if (!props.open) return null;
  return (
    <Suspense fallback={null}>
      <AuthModal {...props} />
    </Suspense>
  );
};

export default LazyAuthModal;
